import React from "react";
import { useTranslation } from "react-i18next";
import { lang } from "../lang";
import { useState } from "react";


const ConfirmationPopup = (props) => {
  const [ln,setLn] = useState(props?.leg)
  const {t} = useTranslation();

  return (
    <div className="blur-screen-full-area inner-modal flex-center">
      <div className="form-container my-3">
        <h3
          className="text-bold popup-heading text-center fs-3 my-3 px-5"
          style={{ fontSize: "24px" }}
        >
          {lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth[props.title]:""}
        </h3>
        <h5 className="text text-center my-3 mt-4 px-5">{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth[props.subTitle]:""}</h5>

        <div className=" space-between mt-4 d-flex">
          <button
            type="submit"
            onClick={(e)=>{
              e.stopPropagation()
              props?.handleYes()}}
            class="theme-btn px-5 text-center me-3"
            style={{  }}
          >
            {t('Yes')}
          </button>
          <button
            type="submit"
            onClick={(e)=>{e.stopPropagation()
              props?.handleNo()}}
            class="theme-btn px-5 text-center ms-3"
            style={{ }}
          >
            {t('No')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
